import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { BulkSelect } from "@faire/web/slate/icons/foundation/BulkSelect";
import React from "react";
import { CheckAccountVerificationStatusIA } from "../instantAnswers/myAccount-checkAccountVerificationStatus";
import { DoNotHaveRequestedInfoIA } from "../instantAnswers/myAccount-doNotHaveReuqestedInfo";
import { ProvideRequestedInfoIA } from "../instantAnswers/myAccount-provideRequestedInfo";
import { AccountVerificationPendingVisibilityFn } from "../visibilityFunctions/accountVerificationPendingVisibilityFn";
export var useVerifyAccountRetailerNodes = function useVerifyAccountRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    VerifyAccount: {
      id: "VerifyAccount",
      label: strictLocalize({
        id: "cY8Hrf",
        defaultMessage: "Verify account"
      }),
      icon: /*#__PURE__*/React.createElement(BulkSelect, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["CheckVerificationStatus", "ProvideVerificationInformation", "InCompleteVerification"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "+68IVe",
        defaultMessage: "Verify account issue"
      }),
      isNodeVisible: AccountVerificationPendingVisibilityFn
    },
    ProvideVerificationInformation: {
      id: "ProvideVerificationInformation",
      label: strictLocalize({
        id: "xCh/Ym",
        defaultMessage: "Provide verification information"
      }),
      articles: [articles.Account.ORDER_ISSUE],
      instantAnswer: ProvideRequestedInfoIA(strictLocalize),
      level: 3
    },
    InCompleteVerification: {
      id: "InCompleteVerification",
      label: strictLocalize({
        id: "fTaoEj",
        defaultMessage: "Incomplete verification"
      }),
      articles: [articles.Account.NOT_OPEN],
      instantAnswer: DoNotHaveRequestedInfoIA(strictLocalize, articles),
      level: 3
    },
    CheckVerificationStatus: {
      id: "CheckVerificationStatus",
      label: strictLocalize({
        id: "zqbI3X",
        defaultMessage: "Check verification status"
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: CheckAccountVerificationStatusIA(strictLocalize, articles),
      level: 3
    }
  };
};